<template>
  <v-app class="blue-grey lighten-5">
    <app-cabecalho class="mb-1"></app-cabecalho>
    <v-content>
      <v-layout row wrap>
        <v-flex xs12>
          <c-snackbar></c-snackbar>
          <router-view :key="$route.fullPath"></router-view>
        </v-flex>
      </v-layout>
    </v-content>
    <app-rodape class="mt-3"></app-rodape>
  </v-app>
</template>

<script>
import Cabecalho from "@/components/shared/Cabecalho.vue";
import Rodape from "@/components/shared/Rodape.vue";
import SnackBar from "@/components/shared/SnackBar.vue";

export default {
  components: {
    "app-cabecalho": Cabecalho,
    "app-rodape": Rodape,
    "c-snackbar": SnackBar
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
